<div [hidden]="!showLoader"
     [ngClass]="{ 'loader-full': isFullScreen, 'loader-inner': !isFullScreen }"
>
    <div class="loader-anim">
        <img alt="loading" [style.width]="loaderImageWidth" src="/assets/images/loading.gif"/>
    </div>
</div>
